import { useState, useEffect } from 'react'
import FrontPageMenuPopover from './FrontPageMenuPopover'
import apiFetch from '@wordpress/api-fetch'
import styles from './Menu.module.css'
import clsx from 'clsx'

function FrontPageMenu() {
  const [data, setData] = useState(null)
  const [height, setHeight] = useState(null)

  useEffect(() => {
    const headerHeight = document.querySelector('.header')?.offsetHeight - 1
    setHeight(headerHeight)

    async function getMenuData() {
      const MenuData = await apiFetch({
        path: `${import.meta.env.VITE_SITE_URL}/wp-json/myroutes/menu/`,
      })

      setData(MenuData)
    }
    getMenuData()

    window.addEventListener('resize', () => {
      const headerHeight = document.querySelector('.header')?.offsetHeight - 1
      setHeight(headerHeight)
    })
  }, [])

  return (
    <>
      <div
        id="front-page-menu"
        className="hidden lg:block max-w-[1650px] mx-auto w-full inset-x-0 z-20 bg-white menu sticky mt-[-53px]"
        style={{
          top: `${height}px`,
        }}
      >
        <ul className={clsx('frontpage-menu flex justify-center', styles.menu)}>
          {data &&
            data.map((item, index) => {
              if (!item.children.length) {
                return (
                  <li
                    key={index}
                    className="flex items-center"
                  >
                    <a
                      className={styles.anchor}
                      href={item.url}
                      target={item.target}
                    >
                      <span>{item.title}</span>
                    </a>
                  </li>
                )
              } else {
                return (
                  <li key={index}>
                    <FrontPageMenuPopover
                      item={item}
                      className="nav-item"
                      num={index}
                      frontPage={true}
                    />
                  </li>
                )
              }
            })}
        </ul>
      </div>
      <style jsx>{`
        .menu {
          box-shadow: 0px 0px 50px #001836b2;
        }
      `}</style>
    </>
  )
}

export default FrontPageMenu
